import { render, staticRenderFns } from "./reisetermin-comments.vue?vue&type=template&id=33bd101c"
import script from "./reisetermin-comments.vue?vue&type=script&lang=js"
export * from "./reisetermin-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports